import React from 'react';
import { useTranslation } from 'react-i18next';

export const HomeHero = () => {
  const { t } = useTranslation();
  
  return (
    <div className="hero-container">
      <img 
        src="/images/company-banner.jpg" 
        alt="SPID Consultants Team"
        className="hero-image"
      />
      <div className="hero-text">
        <h1>{t('companyName')}</h1>
        <p>{t('companyDescription')}</p>
      </div>
    </div>
  );
};
